import React from 'react';
import { X, ChevronRight } from 'lucide-react';

export default function PaymentModal({ isOpen, onClose, plan, planName, price, billingCycle, onCardPayment, onCryptoPayment }) {
  if (!isOpen) return null;

  const isYearly = billingCycle === 'yearly';
  const displayPrice = isYearly ? plan?.price_yearly : plan?.price_monthly;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 460, borderRadius: 20, padding: 'var(--space-2xl)' }}>
        <button className="modal-close" onClick={onClose} aria-label="Close">
          <X size={18} />
        </button>

        <div style={{ textAlign: 'center', marginBottom: 'var(--space-xl)' }}>
          <h3 style={{ color: 'var(--text-primary)', fontSize: 18, fontWeight: 700, marginBottom: 6 }}>
            Upgrade to {planName}
          </h3>
          <div style={{
            display: 'inline-block', padding: '10px 20px',
            background: 'var(--accent-glow)', borderRadius: 14, marginTop: 6,
          }}>
            <span style={{ fontSize: 28, fontWeight: 800, color: 'var(--accent-primary)' }}>
              ${displayPrice}
            </span>
            <span style={{ color: 'var(--text-tertiary)', fontSize: 11, marginLeft: 4 }}>
              {isYearly ? '/year' : '/mo'}
            </span>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button onClick={onCardPayment} className="pay-option-btn">
            <span className="icon">💳</span>
            <div className="body">
              <div className="title">Card / Bank Transfer</div>
              <div className="desc">Instant activation · All major cards</div>
            </div>
            <ChevronRight size={16} color="var(--text-secondary)" />
          </button>

          <button onClick={onCryptoPayment} className="pay-option-btn">
            <span className="icon">₮</span>
            <div className="body">
              <div className="title">Pay with Crypto</div>
              <div className="desc">USDT · BTC · ETH</div>
            </div>
            <ChevronRight size={16} color="var(--text-secondary)" />
          </button>
        </div>

        <button
          onClick={onClose}
          style={{
            width: '100%', padding: 10, borderRadius: 10, marginTop: 12,
            border: '1px solid var(--border-primary)', background: 'transparent',
            color: 'var(--text-secondary)', cursor: 'pointer', fontSize: 13,
            fontFamily: 'inherit',
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
